import { styled } from '@linaria/react';
import { fonts, semantic, size, space } from '../../theme/tokens';

export const Card = styled.div`
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${size.radius['radius-xl']};
  padding: ${space['space-800']};
  display: flex;
  flex-direction: column;
  gap: ${space['space-500']};
`;

export const Heading = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;
